var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-vs-b--rotation-modal"},[_c('img',{attrs:{"src":"https://cloud.aleacontrol.com/media/vSoccer/please-rotate.svg","alt":"please-rotate-screen"}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('modal_device_rotation'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }